import React, { useEffect, useState } from 'react';
import '../FAQs/FAQs.scss'
import Accordian from '../shared/Accordian/Accordian';
import FAQPricingChangeJson from  '../../assets/json/pricingChangeFaqs.json';
import FAQsJson from  '../../assets/json/faqs.json';
import FAQAcivityBillingJson from '../../assets/json/activityBillingFaqs.json';

const FAQ :React.FC = () => {

    const [faqs, setFAQ] = useState<any[]>();
    const [faqAbs, setABFAQ] = useState<any[]>();
    const [faqPcs, setPCFAQ] = useState<any[]>();
    const onTop = () => {
        window.scrollTo(0, 0);
      }
     
    useEffect(()=>{        
        setFAQ(FAQsJson.FAQS);
        onTop();
    },[])

    useEffect(()=>{        
        setPCFAQ(FAQPricingChangeJson.FAQS);
        onTop();
    },[])

    useEffect(()=>{        
        setABFAQ(FAQAcivityBillingJson.FAQS);
        onTop();
    },[])

    return(
    <div className="faq-container">
    <div className="text-align-center faq-header">API Pricing Change FAQ</div>
       <div className="faq-accordion-div">
           { faqPcs &&
               faqPcs.map((faqPcs, key) => (
                <Accordian  key={key} allowMultipleExpanded={true} allowZeroExpanded={true} heading={faqPcs.Question} content={faqPcs.Answer}></Accordian>
              ))
           }
     
       </div>

       <div className="text-align-center faq-header">Pricing FAQ</div>
       <div className="faq-accordion-div">
           { faqs &&
               faqs.map((faq, key) => (
                <Accordian  key={key} allowMultipleExpanded={true} allowZeroExpanded={true} heading={faq.Question} content={faq.Answer}></Accordian>
              ))
           }
     
       </div>
       
       <div className="text-align-center faq-header">Activity & Billing Reports FAQ</div>
       <div className="faq-accordion-div">
           { faqAbs &&
               faqAbs.map((faqAbs, key) => (
                <Accordian  key={key} allowMultipleExpanded={true} allowZeroExpanded={true} heading={faqAbs.Question} content={faqAbs.Answer}></Accordian>
              ))
           }
     
       </div>
    </div>)

}

export default FAQ;